import React from 'react';
import { ConfigurationItem, FilterOption } from '../types';

/**
 * Transform configuration items to table rows format (core-app format)
 */
export const transformToTableRows = (items: ConfigurationItem[]) => {
  return items.map(item => ({
    key: item.identifier,
    data: [
      item.identifier,
      item.locale,
      item.product_type,
      item.product_segment,
      item.operating_company,
      item.asset_type,
      item.environment,
      item.new_business_effective_date,
      item.renewal_effective_date,
      item.bind_active_date,
      {
        component: renderGithubLink(item.github_links),
        allowOverflow: false,
      },
    ],
  }));
};

/**
 * Render GitHub link cell
 */
const renderGithubLink = (url: string | string[]) => {
  let path: string | undefined;

  if (Array.isArray(url)) {
    if (url.length === 1) {
      path = url[0];
    } else {
      const gzFile = url.find(item => item.includes('.json.gz'));
      path = gzFile || url[0]; // Fallback to first item if no .gz file found
    }
  } else {
    path = url;
  }

  if (!path) {
    return <span>N/A</span>; // Handle empty/invalid URLs
  }

  return (
    <a href={path} target="_blank" rel="noreferrer">
      View
    </a>
  );
};

/**
 * Transform string array to filter options
 */
export const transformToFilterOptions = (options: string[]): FilterOption[] => {
  return options.map(option => ({
    key: option,
    label: option,
    selected: false,
  }));
};
